<template>
    <el-dialog class="dialog" :visible.sync="visible" width='400px' top='10vh' @close="dialogClose">
      <file-uploader :options='uploadOptions' :acceptType="acceptType" :single="single" :autoStart='true' @complete="allFilesUploaded"></file-uploader>
    </el-dialog>
</template>
<script>
import FileUploader from './components/index.vue'
export default {
  components:{
    FileUploader
  },
  data() {
    return {
      visible: false,
      single:true,
      acceptType:'',
      uploadOptions: {},
    };
  },
  methods: {
    allFilesUploaded(){
      this.visible=false
      this.callback()
    },
    dialogClose(){
      this.$destroy(); // 销毁实例
      this.$el.remove(); // 从 DOM 中移除元素
    },
  }
};
</script>
<style scoped>
.dialog>>>.el-dialog__header{
  display:none;
}
</style>
